import request from "superagent";
import Promise from "promise";

/**
 * Set cookies
 */
export function setCookies(
	setall = false,
	statistics = false,
	performance = false,
	currentPageId = ""
) {
	var targetUrl = `/umbraco/api/cookie/set`;

	var queryObj = {
		statistics: statistics,
		performance: performance,
		setall: setall,
		currentpageid: currentPageId,
	};

	return new Promise((resolve, reject) => {
		request
			.post(targetUrl)
			.send(queryObj)
			.end((error, response) => {
				if (response.ok) {
					resolve(response.ok);
				} else {
					reject("Error");
				}
			});
	});
}

/**
 * Clear all cookies
 */
export function clearCookies() {
	var targetUrl = `/umbraco/api/cookie/clear`;

	return new Promise((resolve, reject) => {
		request.post(targetUrl).end((error, response) => {
			if (response.ok) {
				resolve(response.ok);
			} else {
				reject("Error");
			}
		});
	});
}
